export default __webpack_public_path__ + "static/dacs08-dc550555c960cab7b08c5fd7ca070565.jpg";